import React from 'react'

import './SearchClients.scss'
import { CrossIcon } from 'assets/icons'

interface Props {
    value?: string,
    placeholder: string,
    onInput: Function
}

interface State {
    keyword: string
}

export default class SearchClients extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            keyword: this.props.value || ''
        }
    }

    public searchByKeyword = (event: KeyboardEvent, keyword: string) => {
        this.props.onInput(keyword)
        // Blur input te hide mobile keyboard
        const input = document.getElementById('searchInput')
        if (input) {
            input.blur()
        }
        event.preventDefault()
    }

    public handleInput = (event: any) => {
        if (event.target.value === '') {
            this.emptyResults(event)
        } else {
            this.setState({
                keyword: event.target.value
            })
        }
    }

    public emptyResults = (event: any) => {
        this.searchByKeyword(event, '')
        this.setState({
            keyword: ''
        })
    }

    public render() {

        const { placeholder } = this.props
        return (
            <div id="search-clients">
                <form
                    action="."
                    name="search"
                    onSubmit={(event: any) =>
                        (this.searchByKeyword(event, this.state.keyword))}
                >

                    <div className="input-row">
                        <label htmlFor="searchInput" className="u-hidden">
                            Search by keyword
                        </label>
                        <input
                            id="searchInput"
                            type="search"
                            name="keyword"
                            value={this.state.keyword}
                            placeholder={placeholder}
                            onChange={event => this.handleInput(event)}
                        />
                        { this.state.keyword &&
                            <a href="#" className="close" onClick={(event) => this.emptyResults(event)}>
                                <CrossIcon stroke="#666"/>
                            </a>
                        }
                    </div>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchClients/index.tsx